import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";

@Component({
    name: "AiCongrats",
    components: {}
})
export default class AiCongrats extends Vue {
    @Prop() private showCongrats: boolean;
    closeCongrats(showCongrats) {
        this.$set(showCongrats, "showCongrats", false);
    }
}

//@ts-ignore
export { default as AiCongrats } from "./index.vue";
